// extracted by mini-css-extract-plugin
module.exports = {"label":"_0cbaba7d8a--label--ulcAo","dark-theme":"_0cbaba7d8a--dark-theme--X6qyP"};